var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkExperienceIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.084,
  cy: 20,
  fill: "#FFF09F",
  rx: 20.045,
  ry: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20.825 20.959h-1.65c-.111 0-.201.09-.201.2v1.659c0 .11.09.2.2.2h1.651c.111 0 .201-.09.201-.2V21.16c0-.111-.09-.201-.2-.201"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.915 14.179H23.51v-1.425c0-.744-.612-1.35-1.363-1.35h-4.294c-.751 0-1.363.606-1.363 1.35v1.425h-3.405A3.09 3.09 0 0 0 10 17.264v1.85a1.59 1.59 0 0 0 1.074 1.195l6.724 1.643v-.793c0-.758.618-1.376 1.377-1.376h1.65c.76 0 1.377.618 1.377 1.377v.792l6.724-1.643c.557-.179.96-.638 1.074-1.195v-1.85a3.09 3.09 0 0 0-3.085-3.085m-4.58 0h-4.67v-1.425c0-.1.081-.175.188-.175h4.294c.107 0 .187.076.187.175z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m29.257 21.437-.034.009-7.068 1.727a1.38 1.38 0 0 1-1.33 1.021h-1.65a1.38 1.38 0 0 1-1.33-1.02l-7.068-1.728-.034-.01A2.8 2.8 0 0 1 10 21.08v4.996c0 1.39 1.13 2.52 2.52 2.52h14.96c1.39 0 2.52-1.13 2.52-2.52V21.08a2.8 2.8 0 0 1-.743.357"
})));
export default SvgWorkExperienceIco;